//@flow
import * as React from 'react';
import classnames from 'classnames';
import WorkingDaysSummary from 'common/entity/components/dayShift/WorkingDaysSummary';
import dayOfWeekSlotsSummaryFactory from './DayOfWeekSlotsSummaryFactory';
import { type DayShift } from 'common/models/internal/DayShift';
import { type List } from 'immutable';
import { type ThemeType } from 'react-css-themr';

type ShiftTimeSlotSummaryProps = {
    slots: List<DayShift>,
    isBreaksWithOffset: boolean
};

type ShiftWorkingSlotsProps = {
    slots: List<DayShift>,
    theme: ThemeType,
    testId: string
};

class ShiftTimeSlotSummary extends React.PureComponent<ShiftTimeSlotSummaryProps> {
    render() {
        const { slots, isBreaksWithOffset } = this.props;
        return (
            <WorkingDaysSummary
                slots={slots}
                isBreaksWithOffset={isBreaksWithOffset}
            />
        );
    }
}

class ShiftWorkingSlots extends React.PureComponent<ShiftWorkingSlotsProps> {
    render() {
        const { slots, theme, testId } = this.props;
        const wrapperProps = {
            className: theme.dayOfWeekWrap
        };
        if (testId) {
            wrapperProps.testId = testId;
        }
        return (
            <div {...wrapperProps}>
                {slots.map(day => {
                    return (
                        <span
                            className={classnames(theme.dayOfWeek, {
                                [theme.noSlots]:
                                    !day.slot.start && !day.slot.end
                            })}
                            key={day.dayOfWeek}
                        >
                            {day.getShortCode()}
                        </span>
                    );
                })}
            </div>
        );
    }
}

const ShiftSlots = dayOfWeekSlotsSummaryFactory({
    TimeSlotsSummary: ShiftTimeSlotSummary,
    TableSlotSummary: ShiftWorkingSlots
});

export default ShiftSlots;
